import { Nix } from '@livecontrol/core-utils';
import { Token } from '../model';

export enum Tokens {
  COMMAND_CENTER_KEY = '__lc_token',
  WEBPLAYER_KEY = '__wp_token'
}

export interface Options {
  persistent?: boolean;
}

export const getItem = (key: string): string | undefined => {
  const v = sessionStorage.getItem(key) ?? localStorage.getItem(key);

  return Nix.isNotNil(v) ? v : undefined;
};

export const removeItem = (key: string): void => {
  sessionStorage.removeItem(key);
  localStorage.removeItem(key);
};

export const setItem = (
  key: string,
  value: string,
  options: Options = { persistent: true }
): void => {
  const storage = options.persistent ? localStorage : sessionStorage;

  storage.setItem(key, value);
};

export const getCommandCenterToken = (): Token | undefined => Token.decode(getItem(Tokens.COMMAND_CENTER_KEY));

export const setToken = (type: Tokens, value: Token | string | undefined, options?: Options): void => {
  // Remove existing value
  removeItem(type);

  if (value) {
    if (typeof value !== 'string') {
      setItem(type, value.jwt, options);
    } else {
      setItem(type, value, options);
    }
  }
};

export const getWebplayerToken = (): string | undefined => getItem(Tokens.WEBPLAYER_KEY);

export const setWebplayerToken = (value: string | undefined, options?: Options): void => {
  removeItem(Tokens.WEBPLAYER_KEY);

  if (value) {
    setItem(Tokens.WEBPLAYER_KEY, value, options);
  }
};
